import { Backdrop, CircularProgress } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { backdropZIndex } from '@swyft/ui';
import React from 'react';

export const LoadingTheme = ({
  open = false,
  primaryButtonBackground
}: {
  open: boolean;
  primaryButtonBackground: string;
}) => (
  <Backdrop
    open={open}
    style={{
      opacity: 1,
      zIndex: backdropZIndex,
      backgroundColor: grey[50]
    }}
  >
    <CircularProgress style={{ color: primaryButtonBackground, marginRight: 10 }} />
    Hold tight, getting the page ready
  </Backdrop>
);
